import { useEffect, useState } from "react";
import useSWR from "swr";
import { fetchEdition } from "@/lib/api";

export const EDITION_SLUG = "001";
export const LANGS = ["en", "fr", "ar"];

export function useEdition(lang) {
  const safe = lang || "en";
  const { data, error, isLoading, mutate } = useSWR(["edition", EDITION_SLUG, safe], () => fetchEdition(EDITION_SLUG, safe), {
    revalidateOnFocus: false,
  });
  return { edition: data?.edition, pages: data?.pages || [], error, isLoading, lang: safe, mutate };
}

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
